/* EmailJS credentials, shared by every form on the site.

   The public key is meant to be shipped in the client bundle - that is how
   EmailJS works - but keeping the three IDs in one place means a template or
   service change is a one-line edit instead of a hunt through components.

   TEMPLATE_ID prints a fixed set of variables, each exactly once:

     from_name · from_email · phone · service · date · message

   So send each value under its own key and never repeat one inside `message`
   - that is what caused phone, email and course to appear twice in the
   enrolment emails. A field the template has no variable for simply will not
   show up; adding one means editing the template in the EmailJS dashboard. */

export const SERVICE_ID = 'service_yffdsaj';
export const TEMPLATE_ID = 'template_eh5rd9u';
export const PUBLIC_KEY = 'J7EPN1JqZCcqA6lU_';

/** Salon phone, as displayed and as dialled. */
export const PHONE_DISPLAY = '065/3585-545';
export const PHONE_TEL = '+381653585545';
